import React, { useMemo } from "react";
import { connect } from "react-redux";

// core components
/*TABS*/
//Styles
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import AuthProvider from "../../auth/AuthProvider";
import CurrencyProvider from "../../components/Forms/CurrencyProvider";
import VestigingProvider from "../../components/Forms/VestigingProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import { formatTitle } from "../../../utils/formatting";
import { Link } from "react-router";
import parseJSONTryCatched from "../../Helpers/JSONTryCatched";
import Algemeen from "./Tabs/Algemeen";
import Zones from "./Tabs/Zones";
import Customize from "./Tabs/Customize";
import Arrangements from "./Tabs/Arrangements";
import { useSwitchToSalesarea } from "../Vestigingen/UseSwitchToSalesarea";

function TafelForm(props) {
  const endPoint = useMemo(() => {
    return "core/tafels";
  }, []);

  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });

  useSwitchToSalesarea(vestiging);
  return (
    <AuthProvider prefix={"tafels"}>
      <CurrencyProvider currency={currency}>
        <VestigingProvider vestiging={vestiging}>
          <JamezzFormV2
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.naam);
            }}
            endPoint={endPoint}
            excludedKeysInOutput={{ group_id: true, vestiging: true, rawApiData: true }}
            extraFields={extraFields}
            extraFormProps={{
              vestiging,
              vestigingId: vestiging?.id ?? props.vestiging_id,
              menukaartVestigingId,
            }}
            mode={"onSubmit"}
            objectsExcludedAsRelation={{ child_tables: true, rawApiData: true }}
            onGetModel={(model) => {
              if (model.qr_code) {
                Object.keys(model.qr_code).forEach((key) => {
                  model["qr_code__" + key] = model.qr_code[key];
                });
              }
              onGetModel(model);
            }}
            pageTitle={getTranslation("tafels.form.pageTitle", "Tafel")}
            pageTitleSubject={
              <small>
                <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
              </small>
            }
            tabs={[
              {
                right: "algemeen",
                tabButton: <TranslationWrapper tKey={"tafels.form.tabs.algemeen"} tDefault={"Algemeen"} />,
                tabContent: <Algemeen />,
              },
              ...(vestiging?.use_arrangements
                ? [
                    {
                      right: "algemeen",
                      tabButton: <TranslationWrapper tKey="Arrangements" tDefault="Arrangements" />,
                      tabContent: <Arrangements />,
                    },
                  ]
                : []),
              {
                right: "algemeen",
                tabButton: <TranslationWrapper tKey={"tafels.form.tabs.zones"} tDefault={"Zones"} />,
                tabContent: <Zones />,
              },
              {
                right: "customize",
                tabButton: <TranslationWrapper tKey={"tafels.form.tabs.customize"} tDefault={"Customize mastercode"} />,

                tabContent: <Customize />,
              },
            ]}
            // parseOutput={{ child_tables: (object) => JSON.stringify(object) }}
            parseOutput={{
              mastercodeJson: (object) => {
                return typeof object == "object" ? JSON.stringify(object) : object;
              },
              custom_data: (object) => {
                return typeof object == "object" ? JSON.stringify(object) : object;
              },
            }}
            // parseOutput2={{
            //   child_tables: (object) => JSON.stringify(object.map((obj) => obj.id)),
            // }}
            parseInput={{
              mastercodeJson: (response) => {
                // console.log(response);
                return response ? parseJSONTryCatched(response) : response;
              },
              child_tables: (response) => {
                return response ? response : [];
              },
              rawApiData: (response) => (response ? parseJSONTryCatched(response) : null),
              custom_data: (response) => {
                try {
                  if (Array.isArray(response) && response.length === 0) {
                    return {};
                  } else {
                    return response ?? {};
                  }
                } catch (e) {
                  return {};
                }
              },
            }}
            revalidateMode={"onChange"}
            rootRight={"tafels"}
          />
        </VestigingProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

//REDUX
const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(TafelForm);
